export const isEmptyObj = (object: Record<string, any>): boolean =>
  Object.keys(object).length === 0;
